import 'css-chunksrc/client/pages/projectPage/kanbanPage/column/taskCreationWrapper/form/styles.scss';export default {
  "form": "_form_jais5_1",
  "input": "_input_jais5_9",
  "button": "_button_jais5_22",
  "buttonIcon": "_buttonIcon_jais5_46",
  "loader": "_loader_jais5_51"
};